import { Component } from "preact";
import Main from "./components/main";
import { connect } from "preact-redux";
import { fetchYearSummary } from "./actions";
import { getLastYear, getCurrentYear } from "../../utils";
import {
  updateYearList,
  setCurrentYear,
} from "../../shared/actions/getYearList";
class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      headerSelectedYear: getCurrentYear(this.props.generalInfo),
    };
    this.onSelectHeaderYear = this.onSelectHeaderYear.bind(this);
  }

  componentDidMount() {
    const { fetchYearSummary } = this.props;
    fetchYearSummary(this.props.globalSelectedYear);
  }

  onSelectHeaderYear(headerSelectedYear) {
    const { fetchYearSummary } = this.props;
    this.setState({ headerSelectedYear });
    this.props.setCurrentYear(headerSelectedYear)
    fetchYearSummary(headerSelectedYear);
  }

  render() {
    const { headerSelectedYear,selectedYear } = this.state;
    const {
      isLoadingYearSummary,
      yearSummaryData,
      yearSummaryError,
    } = this.props;
    return (
      <Main
        isLoadingYearSummary={isLoadingYearSummary}
        yearSummaryData={yearSummaryData}
        yearSummaryError={yearSummaryError}
        headerSelectedYear={this.props.globalSelectedYear}
        onSelectHeaderYear={this.onSelectHeaderYear}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isLoadingYearSummary: state.home.yearSummary.loading,
    yearSummaryData: state.home.yearSummary.data,
    generalInfo: state.generalInfo.data,
    globalSelectedYear:state.yearList.currentYear,
  };
};

const mapDispatchToProps = (dispatch) => ({
  fetchYearSummary: (year) => dispatch(fetchYearSummary(year)),
  setCurrentYear: (year) => dispatch(setCurrentYear(year)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Home);



// WEBPACK FOOTER //
// ./routes/home/index.js